import WrongPartShipped from './WrongPartShipped';
import { withI18n } from 'react-i18next';

export default withI18n()(WrongPartShipped);
